export default __webpack_public_path__ + "media/images/images/backgrounds/ice-cf79fc265c7138776d45cea8bcd38e79.png";